/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

// components
import { Select, message } from "antd";

// misc
import { locales } from "@/constants";
import { tokens as Tokens } from "@/utils/tokens";
import { queryClient } from "@/utils/queryClient";
import { ITokens } from "@/interfaces/User.interface";
import { usePatchUser, useUserInfo } from "@/api/user";
import { useEffect } from "react";

const baseClassName = "language-selector";

/**
 * Language selector component - Select box
 * @returns {JSX.Element}
 */
export const LanguageSelector = (): JSX.Element => {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const tokensInstance = Tokens;
  const userAuth:ITokens | undefined = queryClient.getQueryData(["user-auth"]);
  const { access: accessToken } = userAuth || {};
  const { data: userData } = useUserInfo(tokensInstance.getTokenSub(accessToken) as string);
  const { mutate: patchUser, isLoading, error } = usePatchUser();
  const availableLanguages = Object.keys(i18n?.options?.resources || {});
  const activeLang = i18n.resolvedLanguage;
  
  useEffect(() => {
    if (error) {
      messageApi.open({
        type: 'error',
        content: t('common.language_save_error'),
      });
    }
  }, [error, messageApi, t])
  const optionsData = availableLanguages.map((lang: string) => ({
    value: lang,
    label: t(locales[lang as keyof typeof locales]),
  }));
  return (
    <>
      {contextHolder}
      <Select
        className={`${baseClassName}`}
        defaultValue={activeLang}
        options={optionsData}
        loading={isLoading}
        value={i18n.resolvedLanguage}
        onChange={(v) => {
          i18n.changeLanguage(v)
          if (userData?.uuid) {
            patchUser(
              {
                userId: userData.uuid as string,
                userData: { language: v },
              }
            )
            return;
          }
          
        }}
        style={{maxWidth: 150}}
      ></Select>
    </>
  );
};
